function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Button from '../button';
import Loading from '../loading';
import zhCN from '../locale/zh-cn';
import { func, obj, guid } from '../util';
var makeChain = func.makeChain;
var pickAttrs = obj.pickAttrs;

var noop = function noop() {};

var Inner = /*#__PURE__*/function (_Component) {
  _inherits(Inner, _Component);

  var _super = _createSuper(Inner);

  function Inner() {
    var _this;

    _classCallCheck(this, Inner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getNode", function (name, ref) {
      _this[name] = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "renderHeader", function () {
      var _this$props = _this.props,
          prefix = _this$props.prefix,
          title = _this$props.title;

      var closeLink = _this.renderCloseLink();

      if (title) {
        _this.titleId = guid('dialog-title-');
        return /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefix, "dialog-header"),
          id: _this.titleId,
          ref: _this.getNode.bind(_assertThisInitialized(_this), 'headerNode'),
          role: "heading",
          "aria-level": "1"
        }, title, closeLink);
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderBody", function () {
      var _this$props2 = _this.props,
          prefix = _this$props2.prefix,
          children = _this$props2.children,
          noBodyPadding = _this$props2.noBodyPadding;

      if (children) {
        var _cx;

        return /*#__PURE__*/React.createElement("div", {
          className: cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "dialog-body"), true), _defineProperty(_cx, "".concat(prefix, "dialog-body-no-padding"), noBodyPadding), _cx)),
          ref: _this.getNode.bind(_assertThisInitialized(_this), 'bodyNode')
        }, children);
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderFooter", function () {
      var _cx2;

      var _this$props3 = _this.props,
          prefix = _this$props3.prefix,
          footer = _this$props3.footer,
          footerAlign = _this$props3.footerAlign,
          footerActions = _this$props3.footerActions,
          locale = _this$props3.locale,
          height = _this$props3.height;

      if (footer === false) {
        return null;
      }

      var newClassName = cx((_cx2 = {}, _defineProperty(_cx2, "".concat(prefix, "dialog-footer"), true), _defineProperty(_cx2, "".concat(prefix, "align-").concat(footerAlign), true), _defineProperty(_cx2, "".concat(prefix, "dialog-footer-fixed-height"), !!height), _cx2));
      var footerContent = footer === true || !footer ? footerActions.map(function (action) {
        var btnProps = _this.props["".concat(action, "Props")];

        var newBtnProps = _objectSpread({}, btnProps, {
          prefix: prefix,
          className: cx("".concat(prefix, "dialog-btn"), btnProps.className),
          onClick: makeChain(_this.props["on".concat(action[0].toUpperCase() + action.slice(1))], btnProps.onClick),
          children: btnProps.children || locale[action]
        });

        if (action === 'ok') {
          newBtnProps.type = 'primary';
        }

        return /*#__PURE__*/React.createElement(Button, _extends({
          key: action
        }, newBtnProps));
      }) : footer;
      return /*#__PURE__*/React.createElement("div", {
        className: newClassName,
        ref: _this.getNode.bind(_assertThisInitialized(_this), 'footerNode')
      }, footerContent);
    });

    _defineProperty(_assertThisInitialized(_this), "renderCloseLink", function () {
      var _this$props4 = _this.props,
          prefix = _this$props4.prefix,
          closeable = _this$props4.closeable,
          onClose = _this$props4.onClose,
          locale = _this$props4.locale;

      if (closeable) {
        return /*#__PURE__*/React.createElement("a", {
          role: "button",
          "aria-label": locale.close,
          href: "javascript:;",
          className: "".concat(prefix, "dialog-close"),
          onClick: onClose
        }, /*#__PURE__*/React.createElement(Button.Icon, {
          type: "primary",
          color: "gray",
          className: "".concat(prefix, "dialog-close-icon"),
          name: "remove"
        }));
      }

      return null;
    });

    return _this;
  }

  _createClass(Inner, [{
    key: "render",
    value: function render() {
      var _cx3;

      var _this$props5 = this.props,
          prefix = _this$props5.prefix,
          className = _this$props5.className,
          size = _this$props5.size,
          closeable = _this$props5.closeable,
          title = _this$props5.title,
          role = _this$props5.role,
          rtl = _this$props5.rtl,
          height = _this$props5.height,
          loading = _this$props5.loading,
          loadingTip = _this$props5.loadingTip,
          others = _objectWithoutProperties(_this$props5, ["prefix", "className", "size", "closeable", "title", "role", "rtl", "height", "loading", "loadingTip"]);

      var newClassName = cx((_cx3 = {}, _defineProperty(_cx3, "".concat(prefix, "dialog"), true), _defineProperty(_cx3, "".concat(prefix, "dialog-").concat(size), true), _defineProperty(_cx3, "".concat(prefix, "closeable"), closeable), _defineProperty(_cx3, className, !!className), _cx3));
      var header = this.renderHeader();
      var body = this.renderBody();
      var footer = this.renderFooter();
      var ariaProps = {
        role: role,
        'aria-modal': 'true'
      };

      if (title) {
        ariaProps['aria-labelledby'] = this.titleId;
      }

      others.style = _extends({}, others.style, {
        height: height
      });
      return /*#__PURE__*/React.createElement("div", _extends({}, ariaProps, {
        className: newClassName
      }, pickAttrs(others), {
        dir: rtl ? 'rtl' : undefined
      }), /*#__PURE__*/React.createElement(Loading, {
        visible: loading,
        tip: loadingTip,
        inline: false
      }, header, body, footer));
    }
  }]);

  return Inner;
}(Component);

_defineProperty(Inner, "propTypes", {
  prefix: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  title: PropTypes.node,
  children: PropTypes.node,
  footer: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
  footerAlign: PropTypes.oneOf(['left', 'center', 'right']),
  footerActions: PropTypes.array,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  okProps: PropTypes.object,
  cancelProps: PropTypes.object,
  closeable: PropTypes.bool,
  onClose: PropTypes.func,
  locale: PropTypes.object,
  role: PropTypes.string,
  rtl: PropTypes.bool,
  // set value for a fixed height dialog. Passing a value will absolutely position the footer to the bottom.
  height: PropTypes.string,

  /**
   * 没有内容区的padding
   */
  noBodyPadding: PropTypes.bool,

  /**
   * 是否处于加载状态
   */
  loading: PropTypes.bool,

  /**
   * 加载提示
   */
  loadingTip: PropTypes.node
});

_defineProperty(Inner, "defaultProps", {
  prefix: 'next-',
  size: 'medium',
  footerAlign: 'right',
  footerActions: ['ok', 'cancel'],
  onOk: noop,
  onCancel: noop,
  okProps: {},
  cancelProps: {},
  closeable: true,
  onClose: noop,
  locale: zhCN.Dialog,
  role: 'dialog',
  noBodyPadding: false,
  loading: false
});

export { Inner as default };